module.exports = new __parcel__URL__("no-issues-glyph.3f423090.svg").toString();